<template>
  <div class="conserve">
    <router-view></router-view>
    <img class="conserve-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
export default {
  name: 'Conserve'
}
</script>

<style scoped>
  @import "Conserve.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/conserve/Conserve.vue